import { type AnyAction } from 'redux';
import {
    APP_INITIALIZATION_FAIL,
    APP_INITIALIZATION_START,
    APP_INITIALIZATION_SUCCESS
} from '../actions/actionTypes/common';
import { LOGOUT } from '../actions/actionTypes/user';
import { APP_INIT_STATUS } from '../../utils/constants';
import { type CommonState } from '../types';

export const initialState: CommonState = {
    appStatus: APP_INIT_STATUS.INITIAL
};

export const common = (state = initialState, action: AnyAction): CommonState => {
    switch (action.type) {
        case APP_INITIALIZATION_START:
            return { ...state, appStatus: APP_INIT_STATUS.PROGRESS };
        case APP_INITIALIZATION_SUCCESS:
            return { ...state, appStatus: APP_INIT_STATUS.SUCCESS };
        case APP_INITIALIZATION_FAIL:
            return { ...state, appStatus: APP_INIT_STATUS.FAIL };
        case LOGOUT:
            return initialState;
        default:
            return state;
    }
};
